<template>
  <a href="javascript:void(0)" @click="submitForm" v-bind="$attrs">
    <slot />
  </a>

  <form ref="form" :action="deepLinkUrl" method="post" class="vm-hidden">
    <input type="text" name="jwt" :value="jwt" />
  </form>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>

<script setup>
import { ref, inject } from "vue";
import { getStoreModuleContext } from "~/utils/store";

const authStore = getStoreModuleContext("auth");
const jwt = authStore.state.accsessToken;

const baseUrl = inject("envSelector").selectedHostEnvConfig.value.custom.unifiedAccountDetailsEndpoint;
const deepLinkUrl = `${baseUrl}/taFeature/accountOptions`;

const form = ref(null);

function submitForm() {
  form.value.submit();
}
</script>
